export default "__VITE_ASSET__Dx4EBcJ2__"